import { VueTsx } from '@/vue-property-decorator'

import { GameCategoryIds } from '../consts/categorys'
import { HomeLayoutType } from '@/api/common/type'
import { useGameStore } from '../store'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import Resource from '@/context/resource'
import Skin from '@/controller/Skin'

/** 占位符替换成Dom元素 */
export class JsxHelper extends VueTsx.Component<unknown> {
  /**
   * 分类图片
   */
  public getGameCategoryImg(id: GameCategoryIds, hidden = false) {
    const { t } = useI18n()
    const { isWeb, isCn, homeLayoutInfos } = useMainStore()
    const { isStake } = Skin.currentTheme() //stake版式取svg图标
    const h5HomeLayoutStyle =
      homeLayoutInfos?.topLayout ?? HomeLayoutType.style0
    const item = [
      ...useGameStore().gameMenuAvailable,
      {
        gameCategoryName: t('lobby.gameMenu.loadingRecent'),
        gameCategoryId: GameCategoryIds.Recent
      },
      {
        gameCategoryName: t('lobby.gameMenu.loadingCollect'),
        gameCategoryId: GameCategoryIds.Collenct
      },
      {
        gameCategoryName: t('lobby.gameMenu.loadingDemo'),
        gameCategoryId: GameCategoryIds.Demo
      }
    ].find((i) => i.gameCategoryId === id)
    // 去除中文中的空格
    const isTrim =
      isCn &&
      item?.gameCategoryName &&
      ((!isWeb && h5HomeLayoutStyle === HomeLayoutType.style1) || hidden)

    if (!item) return ''
    let spriteImg: VueTsxSupport.JSX.Element
    try {
      // 增加异常捕获,解决可能后台设置了值,但该值其实没有真实数据,导致游戏列表崩掉(如果有可能,这个异常捕获,后期还是写入到my-img组件中会更好.)
      spriteImg = isStake ? (
        <span>
          <icon-sprite sprite={Resource.gameMenu[item.gameCategoryId].normal} />
        </span>
      ) : (
        <my-img
          src={Resource.gameMenu[item.gameCategoryId].active}
          width={isWeb ? 40 : 52}
        />
      )
    } catch (error) {
      spriteImg = <div />
    }
    return [
      spriteImg,
      isTrim
        ? (item?.gameCategoryName as string).replace(/\s/g, '')
        : item?.gameCategoryName
    ]
  }
}
// export const JsxHelper = new _JsxHelper()
